import { createContext, createRef } from "react";
import { Pentest, Vulnerability } from "../sdkStructs";

export type WindowType = "logger" | "editor" | "template" | "collaboration";

interface PentestPair {
  pentestId: number;
  setPentestId: (value: number) => void;

  pentest: Pentest | undefined;
  setPentest: (value: Pentest | undefined) => void;

  pentestVulns: Vulnerability[];
  setPentestVulns: (value: Vulnerability[]) => void;
  refreshVulns: () => Promise<void>;

  generating: boolean[];
  setGenerating: (value: (value: boolean[]) => boolean[]) => void;

  selectVulnToGenerate: (data: Vulnerability, id: number) => void;
  selectRemainingVulnsToGenerate: () => void;

  currentWindow: WindowType;
  setCurrentWindow: (value: WindowType) => void;

  scrollToVuln: (value: number) => void;
  vulnRefs: React.RefObject<(HTMLDivElement | null)[]>;

  openVulnModal: (vuln: Vulnerability, orderNumber: number) => void;
  confirmRemoveVuln: (vulnId: number) => void;
}

export const PentestContext = createContext<PentestPair>({
  pentestId: -1,
  setPentestId: () => {},

  pentest: undefined,
  setPentest: () => {},

  pentestVulns: [],
  setPentestVulns: () => {},
  refreshVulns: async () => {},

  generating: [],
  setGenerating: () => {},

  selectVulnToGenerate: () => {},
  selectRemainingVulnsToGenerate: () => {},

  currentWindow: "logger",
  setCurrentWindow: () => {},

  scrollToVuln: () => {},
  vulnRefs: createRef(),

  openVulnModal: () => {},
  confirmRemoveVuln: () => {},
});
